/**
 * Produktseite – Relaunch (Section: main-product-relaunch)
 *
 * Eigenständiges Vanilla-JS, bewusst nicht an Prestiges ProductSection gekoppelt.
 * Zuständig für: Variantenwahl, Preis/Titel/ATC-Status, Galerie, Bundles, Lieferdatum, Ajax-Add-to-Cart.
 * Cart-Drawer: nach erfolgreichem Add wird "product:added" (bubbles) gefeuert, darauf hört Prestiges CartSection.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="product-relaunch"]';

  /* ------------------------------------------------------------------ Utils */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    cents = parseInt(cents, 10) || 0;
    format = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';

    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = match ? match[1] : 'amount';

    function fmt(value, precision, thousands, decimal) {
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? parts.join(decimal) : parts[0];
    }

    var out;
    switch (key) {
      case 'amount_no_decimals': out = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': out = fmt(cents, 2, ' ', ','); break;
      default: out = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function parseJSON(el, fallback) {
    if (!el) { return fallback; }
    try { return JSON.parse(el.textContent || el.innerHTML); } catch (e) { return fallback; }
  }

  function normalize(str) {
    return String(str || '').trim().toLowerCase();
  }

  /* --------------------------------------------------------------- Tracking */
  // Events gehen per Shopify.analytics.publish("<name>_c") an den Custom Pixel (Einstellungen → Kundenereignisse),
  // der sie in GA4-dataLayer-Events übersetzt. Siehe DOKUMENTATION-TRACKING-CUSTOM-PIXEL.md, Abschnitt „Upsell-Tracking“.

  var LIST_ID = 'pdp_bundle_upsell';
  var LIST_NAME = 'PDP Bundle Upsell';

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name + '_c', data);
      }
    } catch (e) { /* Tracking darf die Seite nie stören */ }
  }

  /* --------------------------------------------------------------- Section */

  function ProductRelaunch(section) {
    this.section = section;
    this.settings = parseJSON({ textContent: section.getAttribute('data-rl-settings') }, {}) || {};
    this.product = parseJSON(section.querySelector('[data-rl-product-json]'), null);
    this.bundles = parseJSON(section.querySelector('[data-rl-bundles-json]'), []) || [];
    // Gewählte Bundle-Optionen je Handle: { values: [..], followColor: bool }
    this.bundleSelections = {};
    this.strings = this.settings.strings || {};
    this.moneyFormat = this.settings.moneyFormat || (window.theme && window.theme.moneyFormat);

    if (!this.product) { return; }

    this.form = section.querySelector('[data-rl-form]');
    this.variantInput = section.querySelector('[data-rl-variant-select]');
    this.atcButton = section.querySelector('[data-rl-atc]');
    this.atcText = section.querySelector('[data-rl-atc-text]');
    this.errorBox = section.querySelector('[data-rl-error]');
    this.priceCurrent = section.querySelector('[data-rl-price-current]');
    this.priceBox = section.querySelector('[data-rl-price]');
    this.variantTitle = section.querySelector('[data-rl-variant-title]');
    this.variantMaterial = section.querySelector('[data-rl-variant-material]');
    this.variantMaterials = parseJSON(section.querySelector('[data-rl-variant-materials]'), {}) || {};
    this.delivery = section.querySelector('[data-rl-delivery]');
    this.deliveryText = section.querySelector('[data-rl-delivery-text]');

    this.currentVariant = this._findVariantById(parseInt(this.variantInput && this.variantInput.value, 10)) || this._firstAvailableVariant();
    this.selectedBundle = null;

    this._initGallery();
    this._initVariants();
    this._initBundles();
    this._initQuantity();
    this._initAddToCart();
    this._initSticky();
    this._initRating();
    this._updateDelivery();
    this._updateBundlePrices();
    this._updateSticky();
  }

  ProductRelaunch.prototype = {

    /* ------------------------------------------------------------ Varianten */

    _firstAvailableVariant: function () {
      var variants = this.product.variants || [];
      for (var i = 0; i < variants.length; i++) { if (variants[i].available) { return variants[i]; } }
      return variants[0] || null;
    },

    _findVariantById: function (id) {
      var variants = this.product.variants || [];
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { return variants[i]; } }
      return null;
    },

    _selectedOptionValues: function () {
      var values = [];
      var fieldsets = this.section.querySelectorAll('[data-rl-option]');
      for (var i = 0; i < fieldsets.length; i++) {
        var position = parseInt(fieldsets[i].getAttribute('data-option-position'), 10);
        var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
        values[position - 1] = checked ? checked.value : null;
      }
      return values;
    },

    _variantFromOptions: function (values) {
      var variants = this.product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== null && values[j] !== undefined && v['option' + (j + 1)] !== values[j]) { match = false; break; }
        }
        if (match) { return v; }
      }
      return null;
    },

    _currentColorValue: function () {
      var pos = parseInt(this.settings.colorOptionPosition, 10) || 0;
      if (!pos || !this.currentVariant) { return null; }
      return this.currentVariant['option' + pos] || null;
    },

    _initVariants: function () {
      var self = this;
      var fieldsets = this.section.querySelectorAll('[data-rl-option]');
      if (!fieldsets.length) { return; }

      this.section.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || target.type !== 'radio' || !target.closest('[data-rl-option]')) { return; }

        var fieldset = target.closest('[data-rl-option]');
        var label = fieldset.querySelector('[data-rl-option-value]');
        if (label) { label.textContent = target.value; }

        var previous = self.currentVariant;
        self.currentVariant = self._variantFromOptions(self._selectedOptionValues());
        self._onVariantChanged(previous, self.currentVariant);
      });
    },

    _onVariantChanged: function (previous, variant) {
      // 1. Formularwert
      if (this.variantInput && variant) {
        this.variantInput.value = String(variant.id);
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 2. Preis
      if (this.priceBox) {
        if (!variant) {
          this.priceBox.style.display = 'none';
        } else {
          this.priceBox.style.display = '';
          var html = '<span class="rl-price__current" data-rl-price-current>' + formatMoney(variant.price, this.moneyFormat) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="rl-price__compare" data-rl-price-compare>' + formatMoney(variant.compare_at_price, this.moneyFormat) + '</s>';
          }
          this.priceBox.innerHTML = html;
        }
      }

      // 3. Titel-Suffix
      if (this.variantTitle && this.settings.titleWithVariant) {
        var color = this._currentColorValue();
        if (color) { this.variantTitle.textContent = color; }
      }

      // 3b. Materialname der Variante (Metaobjekt aus custom.material_definition) hinter der Farbe
      if (this.variantMaterial) {
        var material = variant ? this.variantMaterials[String(variant.id)] : null;
        if (material) {
          this.variantMaterial.textContent = ' \u00b7 ' + material;
          this.variantMaterial.hidden = false;
        } else {
          this.variantMaterial.textContent = '';
          this.variantMaterial.hidden = true;
        }
      }

      // 4. ATC
      this._updateAddToCartButton(variant);

      // 5. Galerie
      if (variant && variant.featured_media && variant.featured_media.id) {
        this.goToMedia(variant.featured_media.id);
      }

      // 6. URL
      if (variant && this.settings.enableHistoryState && window.history && window.history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: url }, '', url);
      }

      // 7. Lieferhinweis, Bundle-Preise, Sticky-Leiste, Material im Akkordeon
      this._updateDelivery();
      this._updateAccordionMaterial(variant);
      this._updateBundlePrices();
      this._updateSticky();

      this.section.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: variant, previousVariant: previous }
      }));
    },

    // Akkordeon "Material & Maße": Block der Variante zeigen, sonst den Produkt-Fallback; ohne Material und Maße Punkt ausblenden
    _updateAccordionMaterial: function (variant) {
      var item = this.section.querySelector('[data-rl-material-item]');
      if (!item) { return; }
      var blocks = item.querySelectorAll('[data-rl-material-for]');
      var match = variant ? item.querySelector('[data-rl-material-for="' + variant.id + '"]') : null;
      if (!match) { match = item.querySelector('[data-rl-material-for="fallback"]'); }
      for (var i = 0; i < blocks.length; i++) { blocks[i].hidden = blocks[i] !== match; }
      item.hidden = !match && !item.querySelector('[data-rl-dimensions]');
    },

    _updateAddToCartButton: function (variant) {
      if (!this.atcButton) { return; }
      var bundleSelected = !!this.selectedBundle;
      var text;

      if (bundleSelected) {
        var bundleVariant = this._matchBundleVariant(this.selectedBundle);
        if (bundleVariant && bundleVariant.available) {
          this.atcButton.removeAttribute('disabled');
          text = this.strings.addToCart;
        } else {
          this.atcButton.setAttribute('disabled', 'disabled');
          text = this.strings.soldOut;
        }
      } else if (!variant) {
        this.atcButton.setAttribute('disabled', 'disabled');
        text = this.strings.unavailable;
      } else if (variant.available) {
        this.atcButton.removeAttribute('disabled');
        text = this.strings.addToCart;
      } else {
        this.atcButton.setAttribute('disabled', 'disabled');
        text = this.strings.soldOut;
      }

      if (this.atcText && text) { this.atcText.textContent = text; }
    },

    /* -------------------------------------------------------------- Galerie */

    _initGallery: function () {
      var self = this;
      var gallery = this.section.querySelector('[data-rl-gallery]');
      if (!gallery) { return; }

      this.track = gallery.querySelector('[data-rl-track]');
      this.slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-rl-slide]'));
      this.thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-rl-thumb]'));
      this.prevButton = gallery.querySelector('[data-rl-gallery-prev]');
      this.nextButton = gallery.querySelector('[data-rl-gallery-next]');
      this.activeIndex = 0;

      if (!this.track || !this.slides.length) { return; }

      // Startbild ohne Animation anfahren
      var initial = gallery.querySelector('[data-rl-slide].is-active') || this.slides[0];
      this.activeIndex = this.slides.indexOf(initial);
      if (this.activeIndex > 0) {
        var prevBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = initial.offsetLeft;
        this.track.style.scrollBehavior = prevBehavior;
      }
      this._setActiveSlide(this.activeIndex);

      // Aktiven Slide beim Scrollen erkennen
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              self._setActiveSlide(self.slides.indexOf(entry.target));
            }
          });
        }, { root: this.track, threshold: [0.6] });
        this.slides.forEach(function (slide) { self.observer.observe(slide); });
      } else {
        this.track.addEventListener('scroll', function () {
          var index = Math.round(self.track.scrollLeft / self.track.clientWidth);
          self._setActiveSlide(index);
        });
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', function () { self.goToIndex(self.activeIndex - 1); });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', function () { self.goToIndex(self.activeIndex + 1); });
      }

      this.thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          self.goToIndex(parseInt(thumb.getAttribute('data-index'), 10));
        });
      });

      this.track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); self.goToIndex(self.activeIndex + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); self.goToIndex(self.activeIndex - 1); }
      });

      // Video/Model pausieren, wenn Slide verlassen wird
      this.section.addEventListener('rl:slide:changed', function (event) {
        self.slides.forEach(function (slide, i) {
          if (i === event.detail.index) { return; }
          slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
        });
      });
    },

    _setActiveSlide: function (index) {
      if (index < 0 || index >= this.slides.length) { return; }
      var changed = index !== this.activeIndex;
      this.activeIndex = index;

      this.slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      this.thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) { thumb.setAttribute('aria-current', 'true'); } else { thumb.removeAttribute('aria-current'); }
      });

      if (this.prevButton) { this.prevButton.disabled = index === 0; }
      if (this.nextButton) { this.nextButton.disabled = index === this.slides.length - 1; }

      var activeThumb = this.thumbs[index];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

      if (changed) {
        this.section.dispatchEvent(new CustomEvent('rl:slide:changed', { detail: { index: index } }));
      }
    },

    goToIndex: function (index) {
      if (!this.track || !this.slides.length) { return; }
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      var slide = this.slides[index];
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this._setActiveSlide(index);
    },

    goToMedia: function (mediaId) {
      if (!this.slides) { return; }
      for (var i = 0; i < this.slides.length; i++) {
        if (parseInt(this.slides[i].getAttribute('data-media-id'), 10) === mediaId) { this.goToIndex(i); return; }
      }
    },

    /* -------------------------------------------------------------- Bundles */

    _initBundles: function () {
      var self = this;
      var container = this.section.querySelector('[data-rl-bundles]');
      if (!container) { return; }

      this.bundleCards = Array.prototype.slice.call(container.querySelectorAll('[data-rl-bundle]'));

      this._trackBundleImpression(container);

      container.addEventListener('change', function (event) {
        var input = event.target;
        if (!input) { return; }

        // Option innerhalb eines aufgeklappten Bundles gewählt
        if (input.hasAttribute('data-rl-bopt')) {
          var optHandle = input.getAttribute('data-bundle-handle');
          var position = parseInt(input.getAttribute('data-option-position'), 10) || 1;
          var sel = self.bundleSelections[optHandle];
          if (!sel) { sel = self._initBundleSelection(optHandle); }
          if (!sel) { return; }
          sel.values[position - 1] = input.value;
          if (position === 1) { sel.followColor = false; }
          self._syncBundleOptionUI(optHandle);
          self._updateBundlePrices();
          self._updateAddToCartButton(self.currentVariant);
          self._updateDelivery();
          self._updateSticky();
          return;
        }

        if (!input.hasAttribute('data-rl-bundle-input')) { return; }

        var handle = input.value || null;
        self.selectedBundle = handle ? self._bundleByHandle(handle) : null;

        self.bundleCards.forEach(function (card) {
          var cardInput = card.querySelector('[data-rl-bundle-input]');
          card.classList.toggle('is-selected', cardInput === input);
        });

        if (handle && !self.bundleSelections[handle]) { self._initBundleSelection(handle); }
        self._toggleBundlePanels();
        if (handle) { self._syncBundleOptionUI(handle); }

        self._trackBundleSelect(handle);

        self._updateBundlePrices();
        self._updateAddToCartButton(self.currentVariant);
        self._updateDelivery();
        self._updateSticky();
      });
    },

    /**
     * Startauswahl für ein Bundle: Option 1 folgt der Farbe des Hauptprodukts (wenn vorhanden),
     * die übrigen Optionen kommen aus der ersten dazu passenden verfügbaren Variante.
     */
    _initBundleSelection: function (handle) {
      var bundle = this._bundleByHandle(handle);
      if (!bundle || !bundle.variants || !bundle.variants.length) { return null; }
      var base = this._matchBundleVariant(bundle, true);
      var values = (base && base.options ? base.options : []).slice();
      var sel = { values: values, followColor: true };
      this.bundleSelections[handle] = sel;
      return sel;
    },

    _bundleVariantFromSelection: function (bundle, values) {
      var variants = bundle.variants || [];
      var wanted = (values || []).map(normalize);
      for (var i = 0; i < variants.length; i++) {
        var opts = (variants[i].options || []).map(normalize);
        var match = opts.length === wanted.length;
        for (var j = 0; match && j < wanted.length; j++) { if (opts[j] !== wanted[j]) { match = false; } }
        if (match) { return variants[i]; }
      }
      return null;
    },

    /** Option 1 des Bundles an die Farbe des Hauptprodukts angleichen, solange der Kunde sie nicht selbst geändert hat. */
    _followMainColor: function (handle) {
      var sel = this.bundleSelections[handle];
      var bundle = this._bundleByHandle(handle);
      if (!sel || !sel.followColor || !bundle) { return; }
      var color = this._currentColorValue();
      if (!color) { return; }
      var hasColor = (bundle.variants || []).some(function (v) { return normalize((v.options || [])[0]) === normalize(color); });
      if (hasColor) { sel.values[0] = color; }
    },

    _toggleBundlePanels: function () {
      var self = this;
      var panels = this.section.querySelectorAll('[data-rl-bundle-options]');
      Array.prototype.forEach.call(panels, function (panel) {
        var isOpen = !!(self.selectedBundle && panel.getAttribute('data-rl-bundle-options') === self.selectedBundle.handle);
        panel.hidden = !isOpen;
        var card = panel.previousElementSibling;
        if (card && card.hasAttribute('data-rl-bundle')) { card.classList.toggle('has-options-open', isOpen); }
      });
    },

    /** Radios, Legenden-Werte und Verfügbarkeits-Markierung eines Bundle-Optionsbereichs aktualisieren. */
    _syncBundleOptionUI: function (handle) {
      var panel = this.section.querySelector('[data-rl-bundle-options="' + handle + '"]');
      var sel = this.bundleSelections[handle];
      var bundle = this._bundleByHandle(handle);
      if (!panel || !sel || !bundle) { return; }
      var variants = bundle.variants || [];

      var groups = panel.querySelectorAll('[data-rl-bopt-group]');
      Array.prototype.forEach.call(groups, function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10) || 1;
        var idx = position - 1;
        var current = sel.values[idx];
        var valueLabel = group.querySelector('[data-rl-bopt-value]');
        if (valueLabel) { valueLabel.textContent = current || ''; }

        var radios = group.querySelectorAll('[data-rl-bopt]');
        Array.prototype.forEach.call(radios, function (radio) {
          radio.checked = normalize(radio.value) === normalize(current);

          // Verfügbar, wenn es mit den anderen gewählten Optionen eine lieferbare Variante gibt
          var available = variants.some(function (v) {
            if (!v.available) { return false; }
            var opts = (v.options || []).map(normalize);
            if (opts[idx] !== normalize(radio.value)) { return false; }
            for (var k = 0; k < sel.values.length; k++) {
              if (k !== idx && sel.values[k] && opts[k] !== normalize(sel.values[k])) { return false; }
            }
            return true;
          });
          var swatch = radio.nextElementSibling;
          if (swatch) { swatch.classList.toggle('is-unavailable', !available); }
        });
      });
    },

    _bundleByHandle: function (handle) {
      for (var i = 0; i < this.bundles.length; i++) { if (this.bundles[i].handle === handle) { return this.bundles[i]; } }
      return null;
    },

    /**
     * Passende Variante des Bundle-Produkts: bevorzugt eine, deren Optionen die aktuell gewählte Farbe enthalten,
     * sonst die erste verfügbare, sonst die erste.
     */
    _matchBundleVariant: function (bundle, ignoreSelection) {
      if (!bundle || !bundle.variants || !bundle.variants.length) { return null; }

      // Hat der Kunde im aufgeklappten Bundle Optionen gewählt, zählt genau diese Kombination
      var sel = ignoreSelection ? null : this.bundleSelections[bundle.handle];
      if (sel && sel.values && sel.values.length) {
        var exact = this._bundleVariantFromSelection(bundle, sel.values);
        if (exact) { return exact; }
      }

      var color = normalize(this._currentColorValue());
      var variants = bundle.variants;
      var i;

      if (color) {
        for (i = 0; i < variants.length; i++) {
          var opts = (variants[i].options || []).map(normalize);
          if (opts.indexOf(color) !== -1 && variants[i].available) { return variants[i]; }
        }
        for (i = 0; i < variants.length; i++) {
          var opts2 = (variants[i].options || []).map(normalize);
          if (opts2.indexOf(color) !== -1) { return variants[i]; }
        }
      }
      for (i = 0; i < variants.length; i++) { if (variants[i].available) { return variants[i]; } }
      return variants[0];
    },

    /* ------------------------------------------------------- Bundle-Tracking */

    /** GA4-Item für Hauptprodukt (product-JSON) oder Bundle (bundles-JSON). Preise liegen in Cent vor. */
    _trackItem: function (product, variant, index) {
      return {
        item_id: String(product.id),
        item_name: product.title || '',
        item_brand: product.vendor || '',
        item_category: product.type || '',
        price: variant ? Math.round(variant.price) / 100 : 0,
        item_variant: (variant && variant.title) || 'Default Title',
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        index: index
      };
    },

    /** Alle Karten des Bundle-Blocks als Liste: Index 0 = Hauptprodukt („Nur dieses …“), danach die Bundles. */
    _bundleListItems: function () {
      var self = this;
      var items = [this._trackItem(this.product, this.currentVariant, 0)];
      this.bundles.forEach(function (bundle, i) {
        items.push(self._trackItem(bundle, self._matchBundleVariant(bundle, true), i + 1));
      });
      return items;
    },

    /** view_item_list einmal pro Seitenaufruf, sobald der Bundle-Block zu einem Viertel sichtbar war. */
    _trackBundleImpression: function (container) {
      var self = this;
      var fired = false;

      function fire() {
        if (fired) { return; }
        fired = true;
        publish('view_item_list', { item_list_id: LIST_ID, item_list_name: LIST_NAME, items: self._bundleListItems() });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { observer.disconnect(); fire(); return; }
          }
        }, { threshold: 0.25 });
        observer.observe(container);
      } else {
        fire();
      }
    },

    /** select_item bei jedem Wechsel der Bundle-Karte (nicht bei den Options-Swatches). */
    _trackBundleSelect: function (handle) {
      var bundle = handle ? this._bundleByHandle(handle) : null;
      var item;

      if (bundle) {
        item = this._trackItem(bundle, this._matchBundleVariant(bundle), this.bundles.indexOf(bundle) + 1);
      } else {
        item = this._trackItem(this.product, this.currentVariant, 0);
      }

      publish('select_item', {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        bundle_handle: handle || '',
        bundle_title: bundle ? bundle.title : '',
        items: [item]
      });
    },

    _updateBundlePrices: function () {
      var self = this;
      if (!this.bundleCards || !this.bundleCards.length) { return; }

      // Bundle-Option 1 folgt der Hauptfarbe, Optionsbereiche nachziehen
      Object.keys(this.bundleSelections).forEach(function (handle) {
        self._followMainColor(handle);
        self._syncBundleOptionUI(handle);
      });

      this.bundleCards.forEach(function (card) {
        var handle = card.getAttribute('data-bundle-handle');

        if (!handle) {
          // Einzelkarte = aktuelle Variante
          var single = card.querySelector('[data-rl-single-price]');
          var singleCompare = card.querySelector('[data-rl-single-compare]');
          if (single && self.currentVariant) { single.textContent = formatMoney(self.currentVariant.price, self.moneyFormat); }
          if (singleCompare) {
            var cv = self.currentVariant;
            if (cv && cv.compare_at_price > cv.price) {
              singleCompare.textContent = formatMoney(cv.compare_at_price, self.moneyFormat);
              singleCompare.hidden = false;
            } else {
              singleCompare.hidden = true;
            }
          }
          return;
        }

        var bundle = self._bundleByHandle(handle);
        var variant = self._matchBundleVariant(bundle);
        if (!variant) { return; }

        var price = card.querySelector('[data-rl-bundle-price]');
        var compare = card.querySelector('[data-rl-bundle-compare]');
        var saving = card.querySelector('[data-rl-bundle-saving]');

        if (price) { price.textContent = formatMoney(variant.price, self.moneyFormat); }
        var hasSaving = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) {
          compare.hidden = !hasSaving;
          if (hasSaving) { compare.textContent = formatMoney(variant.compare_at_price, self.moneyFormat); }
        }
        if (saving && hasSaving && self.strings.savingLabel) {
          saving.textContent = self.strings.savingLabel.replace('[betrag]', formatMoney(variant.compare_at_price - variant.price, self.moneyFormat));
        }
      });
    },

    /* ---------------------------------------------------------------- Menge */

    _initQuantity: function () {
      var wrapper = this.section.querySelector('[data-rl-qty]');
      if (!wrapper) { return; }
      var input = wrapper.querySelector('input[name="quantity"]');
      var minus = wrapper.querySelector('[data-rl-qty-minus]');
      var plus = wrapper.querySelector('[data-rl-qty-plus]');

      function current() { return Math.max(parseInt(input.value, 10) || 1, 1); }

      if (minus) { minus.addEventListener('click', function () { input.value = Math.max(current() - 1, 1); }); }
      if (plus) { plus.addEventListener('click', function () { input.value = current() + 1; }); }
      input.addEventListener('change', function () { input.value = current(); });
    },

    /* ----------------------------------------------------------- Lieferdatum */

    _computeDeliveryDate: function (daysToAdd, cfg) {
      var now = new Date();
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var total = daysToAdd + (now.getHours() >= cfg.cutoffHour ? 1 : 0);
      var counted = 0;

      while (counted < total) {
        date.setDate(date.getDate() + 1);
        if (cfg.skipWeekend && (date.getDay() === 0 || date.getDay() === 6)) { continue; }
        counted++;
      }
      if (cfg.skipWeekend) {
        while (date.getDay() === 0 || date.getDay() === 6) { date.setDate(date.getDate() + 1); }
      }
      return date;
    },

    _formatDeliveryDate: function (cfg) {
      var full = new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
      var min = this._computeDeliveryDate(cfg.minDays, cfg);

      if (cfg.maxDays && cfg.maxDays > cfg.minDays) {
        var max = this._computeDeliveryDate(cfg.maxDays, cfg);
        var short = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });
        return short.format(min) + ' – ' + short.format(max);
      }
      return full.format(min);
    },

    _updateDelivery: function () {
      if (!this.delivery || !this.deliveryText) { return; }
      var cfg = this.settings.delivery || {};
      if (!cfg.enabled) { this.delivery.hidden = true; return; }

      var available;
      if (this.selectedBundle) {
        var bv = this._matchBundleVariant(this.selectedBundle);
        available = !!(bv && bv.available);
      } else {
        available = !!(this.currentVariant && this.currentVariant.available);
      }

      this.delivery.hidden = false;
      this.delivery.classList.toggle('rl-delivery--unavailable', !available);

      if (available) {
        var dateString = '';
        try { dateString = this._formatDeliveryDate(cfg); } catch (e) { dateString = ''; }
        this.deliveryText.innerHTML = (this.strings.deliveryText || '[datum]').replace('[datum]', dateString);
      } else {
        this.deliveryText.textContent = this.strings.deliveryUnavailable || '';
      }
    },

    /* ------------------------------------------------------------ Add to cart */

    _initAddToCart: function () {
      var self = this;
      if (!this.form) { return; }

      this.form.addEventListener('submit', function (event) {
        var useAjax = !!self.settings.useAjaxCart;
        var bundleSelected = !!self.selectedBundle;

        // Ohne Drawer und ohne Bundle: normales Formular-Submit
        if (!useAjax && !bundleSelected) { return; }

        event.preventDefault();
        self._addToCart(useAjax);
      });
    },

    _addToCart: function (useAjax) {
      var self = this;
      var quantityInput = this.form.querySelector('[name="quantity"]');
      var quantity = Math.max(parseInt(quantityInput && quantityInput.value, 10) || 1, 1);
      var variant;

      if (this.selectedBundle) {
        variant = this._matchBundleVariant(this.selectedBundle);
      } else {
        variant = this.currentVariant;
      }

      if (!variant || !variant.available) {
        this._showError(this.strings.soldOut || 'Nicht verfügbar');
        return;
      }

      var routes = window.routes || {};
      var addUrl = (routes.cartAddUrl || '/cart/add') + '.js';

      // Herkunft für den Custom Pixel: er hängt sie an Shopifys Standard-Event product_added_to_cart (→ add_to_cart)
      var ctx = {
        variant_id: String(variant.id),
        quantity: quantity,
        source: this.selectedBundle ? 'pdp_bundle' : 'pdp_single'
      };
      if (this.selectedBundle) {
        ctx.item_list_id = LIST_ID;
        ctx.item_list_name = LIST_NAME;
        ctx.bundle_handle = this.selectedBundle.handle;
        ctx.bundle_title = this.selectedBundle.title;
      }
      publish('add_to_cart_context', ctx);

      this._setLoading(true);

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: quantity }] })
      }).then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      }).then(function (result) {
        self._setLoading(false);

        if (!result.ok) {
          self._showError((result.data && (result.data.description || result.data.message)) || 'Fehler beim Hinzufügen.');
          return;
        }

        if (!useAjax) {
          window.location.href = routes.cartUrl || '/cart';
          return;
        }

        // Prestiges CartSection hört auf document-Ebene auf dieses Event und öffnet den Drawer
        self.section.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: variant, quantity: quantity }
        }));
      }).catch(function () {
        self._setLoading(false);
        self._showError('Verbindung fehlgeschlagen. Bitte versuche es noch einmal.');
      });
    },

    _setLoading: function (loading) {
      var buttons = [this.atcButton, this.stickyAtc].filter(Boolean);
      buttons.forEach(function (button) {
        button.classList.toggle('is-loading', loading);
        if (loading) { button.setAttribute('disabled', 'disabled'); } else { button.removeAttribute('disabled'); }
      });
      document.dispatchEvent(new CustomEvent(loading ? 'theme:loading:start' : 'theme:loading:end'));
      if (!loading) { this._updateAddToCartButton(this.currentVariant); this._updateSticky(); }
    },

    /* ------------------------------------------------------------- Sticky ATC */

    _initSticky: function () {
      var self = this;
      this.sticky = this.section.querySelector('[data-rl-sticky]');
      if (!this.sticky || !this.atcButton) { return; }

      this.stickyAtc = this.sticky.querySelector('[data-rl-sticky-atc]');
      this.stickyAtcText = this.sticky.querySelector('[data-rl-sticky-atc-text]');
      this.stickyTitle = this.sticky.querySelector('[data-rl-sticky-title]');
      this.stickyVariant = this.sticky.querySelector('[data-rl-sticky-variant]');
      this.stickyPrice = this.sticky.querySelector('[data-rl-sticky-price]');
      this.stickyImage = this.sticky.querySelector('.rl-sticky__image');

      // Sichtbar, sobald der Haupt-Button nach oben aus dem Viewport gescrollt ist
      if ('IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          self._toggleSticky(passed);
        }, { threshold: 0 });
        this.stickyObserver.observe(this.atcButton);
      } else {
        window.addEventListener('scroll', function () {
          self._toggleSticky(self.atcButton.getBoundingClientRect().bottom < 0);
        }, { passive: true });
      }

      if (this.stickyAtc) {
        this.stickyAtc.addEventListener('click', function () {
          var useAjax = !!self.settings.useAjaxCart;
          if (!useAjax && !self.selectedBundle && self.form) {
            if (self.form.requestSubmit) { self.form.requestSubmit(); } else { self.form.submit(); }
            return;
          }
          self._addToCart(useAjax);
        });
      }

      var scrollLink = this.sticky.querySelector('[data-rl-sticky-scroll]');
      if (scrollLink) {
        scrollLink.addEventListener('click', function (event) {
          event.preventDefault();
          var target = self.section.querySelector('[data-rl-variants]') || self.section;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    },

    // Klick auf die Sterne scrollt zum Reviews-Importify-App-Block (liegt in einer eigenen "apps"-Section mit wechselnder ID)
    _initRating: function () {
      var rating = this.section.querySelector('.rl-rating');
      if (!rating) { return; }

      rating.addEventListener('click', function (event) {
        var target = document.querySelector('[id*="reviews_importify_q_a_product_reviews"]') || document.querySelector('[id^="ri-widget-"]');
        if (!target) { return; }
        event.preventDefault();

        var offset = 16;
        var header = document.getElementById('shopify-section-header');
        if (header) {
          var position = window.getComputedStyle(header).position;
          if (position === 'sticky' || position === 'fixed') { offset += header.offsetHeight; }
        }

        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    },

    _toggleSticky: function (visible) {
      if (!this.sticky) { return; }
      this.sticky.classList.toggle('is-visible', visible);
      this.sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('rl-sticky-active', visible);
    },

    _updateSticky: function () {
      if (!this.sticky) { return; }
      var variant, title, variantLabel, image, available;

      if (this.selectedBundle) {
        variant = this._matchBundleVariant(this.selectedBundle);
        title = this.selectedBundle.title;
        variantLabel = '';
        image = this.selectedBundle.image || null;
      } else {
        variant = this.currentVariant;
        title = this.product.title;
        var color = this._currentColorValue();
        variantLabel = color ? ' \u2014 ' + color : '';
        image = variant && variant.featured_image && variant.featured_image.src ? variant.featured_image.src : null;
      }

      available = !!(variant && variant.available);

      if (this.stickyTitle) { this.stickyTitle.textContent = title || ''; }
      if (this.stickyVariant) { this.stickyVariant.textContent = variantLabel; }
      if (this.stickyPrice && variant) { this.stickyPrice.textContent = formatMoney(variant.price, this.moneyFormat); }
      if (this.stickyImage && image) {
        this.stickyImage.removeAttribute('srcset');
        this.stickyImage.removeAttribute('sizes');
        this.stickyImage.src = image;
      }
      if (this.stickyAtc) {
        if (available) { this.stickyAtc.removeAttribute('disabled'); } else { this.stickyAtc.setAttribute('disabled', 'disabled'); }
        if (this.stickyAtcText) { this.stickyAtcText.textContent = available ? this.strings.addToCart : this.strings.soldOut; }
      }
    },

    _showError: function (message) {
      var self = this;
      if (!this.errorBox) { return; }
      this.errorBox.textContent = message;
      this.errorBox.hidden = false;
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(function () { self.errorBox.hidden = true; }, 4000);
    }
  };

  /* ------------------------------------------------------------------ Boot */

  var instances = new WeakMap();

  function init(root) {
    var sections = (root || document).querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, function (section) {
      if (instances.has(section)) { return; }
      instances.set(section, new ProductRelaunch(section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme-Editor
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
